/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShInternalMailRequest } from '../../models/sh-internal-mail-request';

export interface MailShInternalMail$Params {
  
    /**
     * Request should be one NewEmployeeCandidateRequest, ContactFormRequest, TalkToSalesRequest.
     */
    body: ShInternalMailRequest
}

export function mailShInternalMail(http: HttpClient, rootUrl: string, params: MailShInternalMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, mailShInternalMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

mailShInternalMail.PATH = '/mail/sh-internal-mail';
